export default __webpack_public_path__ + "static/media/icon_elo.94076668.png";